// @ts-strict

import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NgChanges } from '@app/core/models/helpers';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent implements OnInit, OnChanges {
  @Input() placeholder = 'search';
  @Input() mobileMode = false;
  @Input() openedSearchBar = false;
  @Input() dontClose = false;
  @Input() initialValue = '';
  @Input() controlledValue?: string;

  @Output() inputValue = new EventEmitter<string>();

  public searchInput = '';
  private search$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    if (this.initialValue) {
      this.searchInput = this.initialValue;
    }
    if (this.controlledValue) {
      this.searchInput = this.controlledValue;
    }

    this.search$.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(term => {
      this.searchInput = term.trim();
      this.searchHandler();
    });
  }

  ngOnChanges(changes: NgChanges<SearchInputComponent>) {
    if (
      typeof changes.controlledValue?.previousValue === 'string' &&
      typeof changes.controlledValue?.currentValue === 'string' &&
      changes.controlledValue.previousValue !== changes.controlledValue.currentValue
    ) {
      this.searchInput = changes.controlledValue.currentValue;
    }
  }

  public clearSearchInput(): void {
    this.searchInput = '';
    this.searchHandler();
    if (this.mobileMode) {
      this.openedSearchBar = false;
    }
  }

  public searchHandler(): void {
    this.inputValue.emit(this.searchInput);
  }

  public openSearchBar(): void {
    this.openedSearchBar = true;
  }

  public checkInputLength(): void {
    this.search$.next(this.searchInput.trim());
  }

  public closeSearchBar(): void {
    if (this.mobileMode && this.openedSearchBar && this.searchInput.length > 0) {
      return;
    } else if (this.openedSearchBar && !this.dontClose) {
      this.openedSearchBar = false;
    }
  }
}
